import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const dataAccelerationSortOptions: OptionsDictionary = {
  'targetName': {
    id: OrderKeys.targetName,
    getMenuItemDisplayValue: Messages.column_workbook_or_datasource,
    subSortOptions: {
      'asc': {
        id: 'targetName.asc',
        field: OrderKeys.targetName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.targetName)]
      },
      'desc': {
        id: 'targetName.desc',
        field: OrderKeys.targetName,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.targetName)]
      }
    }
  },
  'schedule' : SortOptions.schedule,
  'lastRunAt' : SortOptions.lastRunAt,
  'project' : SortOptions.projectName,
  'owner' : SortOptions.owner,
  'siteName'  : SortOptions.siteName
};
